@if (frameworkAgreement || (editable && (frameworkAgreementOptions?.length || 0) > 0)) {
<div class="px-3">
    <div class="d-flex align-items-center gap-2">
        <strong>{{ 'Rahmenvertrag' | translate }}</strong>
        @if (editable && !frameworkAgreement && (frameworkAgreementOptions?.length || 0) > 0) {
        <button class="text-primary" mat-icon-button (click)="openFrameworkAgreementSelection()">
            <em class="fas fa-pen"></em>
        </button>
        }
    </div>

    @if (frameworkAgreement) {
    <div class="d-flex align-items-center gap-2 mt-1">
        <div class="ps-0" [title]="frameworkAgreement">{{ frameworkAgreement?.agreementNumber }}</div>
        @if (editable) {
        <button class="text-primary" mat-icon-button (click)="openFrameworkAgreementSelection()">
            <em class="fas fa-pen"></em>
        </button>
        <button
            [matTooltip]="'Rahmenvertrag' | translate"
            mat-icon-button
            color="warn"
            (click)="deleteFrameworkAgreement(frameworkAgreement, $event)"
        >
            <em class="fas fa-trash"></em>
        </button>
        }
    </div>
    }
</div>
}
